import Axios from "axios";
import type { VisitorConsentContent } from "../../../features/VisitorConsent/visitor-consent-content.context";

export type VisitorConsentPageContentStateDto = {
  draft: VisitorConsentContent;
  published: VisitorConsentContent;
};

export const fetchVisitorConsentPageContent = () =>
  Axios.get<VisitorConsentPageContentStateDto>("/visit/consent-content");

export const saveVisitorConsentPageDraft = (content: VisitorConsentContent) =>
  Axios.put("/visit/consent-content/draft", content);

export const publishVisitorConsentPageDraft = () => Axios.post("/visit/consent-content/publish");
